import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        <Card.Text style={{ textAlign: "justify" }}>
          <span className="purple" style={{ fontWeight: "bolder" }}>Technology Used:</span> {props.tech}
        </Card.Text>
        <Button style={{ marginTop: "auto" }} variant="primary" href={props.link} target="_blank">
          <BiLinkExternal /> &nbsp;
          {props.isLink ? "Visit Site" : "View Project"}
        </Button>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
